import { useTranslation } from 'react-i18next'
import { Header } from '@/components/layout/header'
import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'
import LanguageSwitcher from '@/components/language-switcher'
import { PlatformNotificationsDropdown } from '@/features/notifications/plataform-notification'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { tokens } from '@/locales/translations/tokens'

interface AppHeaderProps {
  fixed?: boolean
  children?: React.ReactNode
}

export function AppHeader({ fixed, children }: AppHeaderProps) {
  const { t } = useTranslation()

  return (
    <Header fixed={fixed}>
      {children}
      <Search placeholder={t(tokens.ui.common.searchInput)} />
      <div className='ml-auto flex items-center space-x-4'>
        <ThemeSwitch />
        <LanguageSwitcher />
        <PlatformNotificationsDropdown />
        <ProfileDropdown />
      </div>
    </Header>
  )
} 